var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#81D61E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8867 32.6663H27.1133C30.3333 32.6663 31.6167 30.6947 31.7683 28.2913L32.375 18.6547C32.5383 16.1347 30.5317 13.9997 28 13.9997C27.2883 13.9997 26.635 13.5913 26.3083 12.9613L25.4683 11.2697C24.9317 10.208 23.5317 9.33301 22.3417 9.33301H19.67C18.4683 9.33301 17.0683 10.208 16.5317 11.2697L15.6917 12.9613C15.365 13.5913 14.7117 13.9997 14 13.9997C11.4683 13.9997 9.46167 16.1347 9.625 18.6547L10.2317 28.2913C10.3717 30.6947 11.6667 32.6663 14.8867 32.6663Z",
    stroke: "#004222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 16.333H22.75",
    stroke: "#004222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28.0003C23.0883 28.0003 24.7917 26.297 24.7917 24.2087C24.7917 22.1203 23.0883 20.417 21 20.417C18.9117 20.417 17.2083 22.1203 17.2083 24.2087C17.2083 26.297 18.9117 28.0003 21 28.0003Z",
    stroke: "#004222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.55ce038aff454101350b9c7e221db59a.svg";
export { ForwardRef as ReactComponent };